import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=f59b5488&scoped=true"
import script from "./recordDetails.vue?vue&type=script&lang=js"
export * from "./recordDetails.vue?vue&type=script&lang=js"
import style0 from "./recordDetails.vue?vue&type=style&index=0&id=f59b5488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59b5488",
  null
  
)

export default component.exports